import React from 'react';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {history} from '../routers/AppRouter';
import ScrollArea from 'react-scrollbar';
import API from './api';
import PageAnimation from '../components/PageTransitions';
import posed from 'react-pose';
import SimpleReactValidator from 'simple-react-validator'

const Box = posed.div({
  //hoverable: true,
  hidden: {
    scale: 1,
    originX: 0,
    originY: 0,
    opacity:0,
    color: "rgb(104, 150, 42)",
  },
  visible: {
    scale: 1,
    opacity:1,
    color: "#ffffff",
  }
});
const Input = posed.input({
  focusable: true,
  init: {
    boxShadow: '0px 5px 10px rgba(0,0,0,0)',
    
  },
  focus: {
    boxShadow: '0px 5px 10px rgba(0,0,0,0.2)',
  }
});
const Textarea = posed.textarea({
  focusable: true,
  init: {
    boxShadow: '0px 5px 10px rgba(0,0,0,0)',
    
  },
  focus: {
    boxShadow: '0px 5px 10px rgba(0,0,0,0.2)',
  }
});



class ContactPage extends React.Component{
  constructor() {
    super();
    this.validator = new SimpleReactValidator();
  }
  state = {
    inputOne: true,
    name:'',
    phone:'',
    email:'',
    message:'',
    error: false,
    success:false,
    sendText:'send',
    address:[],
    number:[]
  };
  
  componentWillMount = () =>{
    this.setState({message:''});

    if (this.props.contactData.dataIn){
      // if data stored on Redux
      this.setState({
        address:this.props.contactData.address,
        number:this.props.contactData.number
      });
      
    } else{
      // if data not stored on Redux try to fetch again
      API.get(`about`)
      .then(res => {
        const contactData = res.data;
        this.setState({
          address:this.props.contactData.address,
          number:this.props.contactData.number
        });
      });
    }

  }
  handelNameChange = (e) =>{
    this.setState({name:e.target.value});
  }
  handelphoneChange = (e) =>{
    this.setState({phone:e.target.value});
  }
  handelemailChange = (e) =>{
    this.setState({email:e.target.value});
  }
  handelmessageChange = (e) =>{
    this.setState({message:e.target.value});
  }
  handleContactForm = (e) =>{
    e.preventDefault();
    console.log(this);
    if( this.validator.allValid() ){
      const msg = {
        Name: this.state.name,
        Phone: this.state.phone,
        Email: this.state.email,
        Message:this.state.message
      };
      this.setState({sendText:'sending...'});
      API.post(`contact`, { msg })
      .then(res => {
        console.log(res);
        console.log(res.data);
        console.log({msg});
        this.setState({success:true,error:false,sendText:'send',message:''});


        // Event snippet for Contact Form Clicks conversion page
        //In your html page, add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button. -->   
        function gtag_report_conversion(url) {
          var callback = function () {
            if (typeof(url) != 'undefined') {
              window.location = url;
            }
          };
          gtag('event', 'conversion', {
              'send_to': 'AW-385926089/dgOHCK361okCEMmHg7gB',
              'event_callback': callback
          });
          return false;
        }

      }).catch(error => {
        console.log(error);
        this.setState({success:false,error:true,sendText:'resend'})
      });
      //console.log("Name: " + this.state.name + "\nPhone: " + this.state.phone + "\nEmail: " + this.state.email +"\nMessage: " + this.state.message)
    } else {
      this.validator.showMessages();
      // rerender to show messages for the first time
      this.forceUpdate();
    }
  }
  
  render(){
      return(
        <PageAnimation frompage={history.location.state.prevPath} topage={history.location.pathname}  animP="/contact">
        <ScrollArea
            smoothScrolling={true}
            onScroll={() => {
              document.querySelector(".logo").classList.remove("home");
            }}
            className="contactPage"
            verticalContainerStyle={{background:"#679727"}}
            verticalScrollbarStyle={{background:"#abe261"}}
            horizontal={false}
            >
          <div className="topShadow"></div>
          <div className="fixedNav">
            <Link className="back" to={{pathname: 'work', state: { prevPath: location.pathname }}}><span className="icon-back-left"></span> Work</Link>
            <Link className="current" to={{pathname: 'about', state: { prevPath: location.pathname }}}><span className="icon-back-left"></span> About</Link>
          </div>
          <div className="bContainer">
            <div className="title">
              <p>Work / Website solutions</p>
              <h1>Contact us</h1>

            </div>
            <div className="content">
                <div className="row">
                  <div className="col-sm-4 col-xs-12 hidden-sm hidden-md hidden-lg">
                        
                        <div className="tableWarp">
                        <table className="addressInfo">
                        <tbody>
                        <tr>
                          <td><h3>Address:</h3></td>
                          <td>
                            {this.state.address.map((addres, index) => (
                              <p key={index}>
                                {addres === '/' ? <br></br> : addres}
                              </p>
                            ))}
                          </td>
                        </tr>
                        <tr>
                          <td><br></br><h3>Phones:</h3></td>
                          <td>
                          <br></br>
                            {this.state.number.map((number, index) => (
                              <p key={index}>
                                {number}
                              </p>
                            ))}
                          </td>
                        </tr>
                        </tbody>
                      </table>
                        </div>
                      </div>
                      <div className="col-sm-7 col-xs-12">
                        
                        <form onSubmit={this.handleContactForm}>
                          <Box pose={this.state.inputOne ? 'visible' : 'hidden'}>
                            <h2>What is your first name ?</h2>
                            <Input type="text" value={this.state.name} onChange={this.handelNameChange} className="input" placeholder="Type your answer here"></Input>
                            {this.validator.message('name', this.state.name, 'required')}
                          </Box>
                          <Box pose={this.state.name ? 'visible' : 'hidden'}>
                            <h2>What is your phone number ?</h2>
                            <Input type="text" value={this.state.phone} onChange={this.handelphoneChange} className="input" placeholder="Type your answer here"></Input>
                            {this.validator.message('phone number', this.state.phone, 'required|phone')}
                          </Box>
                          <Box pose={this.state.phone && this.state.name ? 'visible' : 'hidden'} >
                            <h2>What is your e-mail ?</h2>
                            <Input type="text" value={this.state.email} onChange={this.handelemailChange} className="input" placeholder="Type your answer here"></Input>
                            {this.validator.message('e-mail', this.state.email, 'required|email')}
                          </Box>
                          <Box pose={this.state.email && this.state.phone && this.state.name  ? 'visible' : 'hidden'}>
                            <h2>Your message</h2>
                            <Textarea type="text" value={this.state.message} onChange={this.handelmessageChange} className="input" rows="4" placeholder="Type your message here"></Textarea>
                          </Box>
                          <Box pose={this.state.email && this.state.phone && this.state.name && this.state.message ? 'visible' : 'hidden'} >
                            <button className={`button green ${this.state.sendText === 'sending...'?'disable':''}`}>{this.state.sendText}</button>
                          </Box>
                          { this.state.error && 
                            <p className="contact-form-error">
                              {this.state.name}, there was an error with sending your message.<br></br>If the error still persists please try again later or send directly to hi@bni.agency.
                            </p>
                          }
                          { this.state.success && 
                            <p className="contact-form-success">
                              {this.state.name}, thank you for getting in touch!<br></br>
                                One of our team members will get back to you shortly.<br></br>
                                Have a great day!
                            </p>
                          }
                        </form>
                      </div>
                      <div className="col-sm-5 col-xs-12 hidden-xs">
                        
                        <div className="tableWarp">
                        <table className="addressInfo">
                        <tbody>
                        <tr>
                          
                          <td>
                            {this.state.address.map((addres, index) => (
                              <p key={index}>
                                {addres === '/' ? <br></br> : addres.includes('*') ? <strong>{addres.replace('*','')}</strong>  : addres}
                                
                              </p>
                            ))}
                          </td>
                        </tr>
                        <tr>
                          
                          <td>
                          <br></br>
                            {this.state.number.map((number, index) => (
                              <p key={index}>
                                {number}
                              </p>
                            ))}
                          </td>
                        </tr>
                        </tbody>
                      </table>
                        </div>
                      </div>
                      
                </div>
              
            </div>
          </div>
        </ScrollArea>
        </PageAnimation>
      );
  }
}


const mapStateToProps = (state) =>{
  return{
      contactData: state.contact
  };
};


export default connect(mapStateToProps)(ContactPage);



// WEBPACK FOOTER //
// ./src/components/ContactPage.js